module.exports = __webpack_public_path__ + "img/yellow-square-table-4.457450a0.png";